var keyMirror = require('./../../lib/keyMirror');

module.exports = keyMirror({
  'anjuke_agenthousetype': null,
  'anjuke_agentkft': null,
  'anjuke_agentloupan': null,
  'anjuke_awardnotification': null,
  'anjuke_callphone': null,
  'anjuke_fangyuan': null,
  'anjuke_fangyuan2': null,
  'anjuke_focusReq': null,
  'anjuke_houseConfirm': null,
  'anjuke_housestatecard': null,
  'anjuke_invitecallcard': null,
  'anjuke_invitecommentcard': null,
  'anjuke_kftcard': null,
  'anjuke_propertycardv2': null,
  'anjuke_publiccard2': null,
  'anjuke_publicmsgcard': null,
  'anjuke_reportprogresscard': null,
  'anjuke_richcontent_articles': null,
  'anjuke_richcontent1': null,
  'anjuke_signup_success': null,
  'anjuke_tip': null,
  'anjuke_qamsgcard': null,
  'anjuke_brokertip': null,
  'anjuke_systemtip': null,
  'anjuke_agentlike': null,
  'anjuke_qa': null,
  'anjuke_recommendprop3': null,
  'cheshangtong_post': null,
  'ershouche_cheshangtong_system': null,
  'ershouche_cheshangtong_weixin': null,
  'ershouche_cheshangtong_yxfk': null,
  'esc_phone_remind': null,
  'evaluate_card': null,
  'ganji_job_resume_viewed': null,
  'ganji_job_resume_pass': null,
  'ganji_job_resume_unpass': null,
  'ganji_job_resume_down': null,
  'ganji_job_resume_interview': null,
  'ganji_job_resume_integrity': null,
  'gj_card_job_recommendation': null,
  'ganji_gfxx_cardtwc': null,
  'ganji_gfxx_cardwc': null,
  'gj_define': null,
  'gj_notice_post': null,
  'gj_post': null,
  'house_publisher_card': null,
  'house_broker_card': null,
  'kf_card1': null,
  'kf_card2': null,
  'kf_card3': null,
  'kf_card4': null,
  'kf_card5': null,
  'kf_card6': null,
  'kf_card7': null,
  'kf_card8': null,
  'kf_card9': null,
  'kf_card10': null,
  'kf_card11': null,
  'nhr_card1': null,
  'old_im_system_msg': null,
  'ss_helplist': null,
  'ss_postcard_list': null,
  'standard_evaluate_card1_ret': null,
  'weiliaoke_evaluationsucceed': null,
  'wuba_card': null,
  'wuba_card1': null,
  'yingcai_emoji_message': null,
  'yingcai_get_confirm_phone': null,
  'yingcai_get_cv': null,
  'yingcai_get_merge_msg': null,
  'yingcai_get_smartReply': null,
  'yingcai_get_want_phone': null,
  'yingcai_get_want_resume': null,
  'yingcai_get_zhiwei': null,
  'zcm_syjl': null,
  'zcm_sysmsg': null,
  'zufanglivecard': null,
  'ershouche_cheshangtong_report': null,
  'house_call_card': null,
  'tz_card_notify': null,
  'gy_publisher_card': null,
  'ajk_redpackage': null,
  'tz_card_friend_sincerewords': null,
  'esc_recept_merchant_call': null
});
